import {useState} from 'react';
import './App.css';
import Board from "./components/Board";

function App() {
    const initSquares = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, null];
    const [squares, setSquares] = useState(initSquares.sort((a, b) => Math.random() - 0.5));
    const [currentMove, setCurrentMove] = useState(0);

    function handlePlay(nextSquares, index) {
        setCurrentMove(currentMove + 1);
        setSquares(nextSquares);
    }

    return (
        <div className="game">
            <div className="game-board">
                <Board squares={squares} onPlay={handlePlay} currentMove={currentMove}/>
            </div>
        </div>
    )
}

export default App;
